import { Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'user-profile-change-password',
  templateUrl: './user-profile-change-password.component.html',
  styleUrls: ['./user-profile-change-password.component.css']
})

export class UserProfileChangePasswordComponent implements OnInit, OnDestroy {
  private user = new PasswordChange();
  private changePasswordResponseErr: string[] = [];
  private modalId: string;
  private subs = new SubSink();

  @ViewChild('editForm', { static: false }) editForm: NgForm;
  @ViewChild('changePasswordMsg', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modalId = 'changePasswordMsg';
  }

  private changePassword() {
    if (this.editForm.valid) {

      this.msgDialog.show('Are you sure you change password?', MessageType.YESNO, 'Update user password!', () => {

        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Change password failed.', 'error');
          } else {
            this.subs.sink = this.repository.post<PasswordChangeHttpResponse>('api/User/ChangePassword', this.user, afResp.data).subscribe(resp => {
              if (!resp.data.isSaved)
                this.changePasswordResponseErr = resp.data.errors;

              if (resp.hasErrors && !resp.data.isSaved) {
                Toast.Show(resp.error, 'Change password failed.', 'error');
              }

              if (resp.hasErrors && !resp.data.isSaved) {
                Toast.Show('Password succsessfully changed', 'User profile', 'success');
              }

              this.editForm.reset();
            }); 
          }
        });
      });
    } else {
      Object.keys(this.editForm.controls).forEach(fieldName => {
        this.editForm.controls[fieldName].markAsDirty();
      });

      $('#currentPassword').focus();
    }

  }

  private confirmPass(e: any) {
    this.editForm.controls['confirmPassword'].setErrors({ 'passwordDoNotMatch': true });

    if (this.editForm.controls['newPassword'].value === e.target.value) {
      this.editForm.controls['confirmPassword'].setErrors(null);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

export class PasswordChange {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export class PasswordChangeHttpResponse {
  isSaved: boolean;
  errors: string[];
}
